import { useState} from 'react'
import CloseIcon from '../../../assets/icons/close.svg?react';
import EditIcon from '../../../assets/icons/edit.svg?react';
import DeleteIcon from '../../../assets/icons/delete.svg?react';

const DRDetailModal = ({ onClose, demandResource, onChargerComp }) => {
  
  return (
    <div className="detail-modal-background">
      <div className="detail-modal-container">
        <div className="detail-modal-header">
          <h3>DR 자원 상세정보</h3>
          <button className='close-btn' onClick={onClose}>
            <CloseIcon />
          </button>
        </div>
        <div className="detail-modal-content">
          <div className='detail-modal-content-divide-container'>
            <div className='detail-modal-content-divide-content left'>
              {/* LEFT HEADER */}
              <div className='detail-modal-content-divide-content-header flex align-center gap-5'>
                <h3 className='text-b1-700 text-primary'>{demandResource.ResourceName}</h3>
                <button className='btn icon-btn'>
                  <EditIcon color='var(--gray-600)'/>
                </button>
                <button className='btn icon-btn'>
                  <DeleteIcon color='var(--gray-600)'/>
                </button>
              </div>
              {/* LEFT CONTENT */}
              <div className='flex flex-col gap-10 mt-10 mb-20'>
                <h3 className='text-b1-700 text-base'>기본 정보</h3>
                <table className='gray-table'>
                  <tr>
                    <th>DR 자원 이름</th>
                    <td>{demandResource.ResourceName}</td>
                  </tr>
                  <tr>
                    <th>지역구분코드</th>
                    <td>{demandResource.RegionCode}</td>
                  </tr>
                  <tr>
                    <th>시도</th>
                    <td>{demandResource.RegionSido}</td>
                  </tr>
                  <tr>
                    <th>시군구</th>
                    <td>{demandResource.RegionSiGunGu}</td>
                  </tr>
                  <tr>
                    <th>읍면동</th>
                    <td>{demandResource.RegionEupMyeonDong}</td>
                  </tr>
                </table>
              </div>
              
              <div className='flex flex-col gap-10 mt-10 mb-20'>
                <h3 className='text-b1-700 text-base'>할당된 EV 충전소</h3>
                <div className='map-container'></div>
              </div>
              
            
              

            </div>
            <div className='detail-modal-content-divide-content right'>
              {/* RIGHT CONTENT */}
              <div className='flex flex-col gap-10 mb-20'>
                <h3 className='text-b1-700 text-base'>충전소 과거 24시간 전력 수요 이력</h3>
              </div>
              
              <div className='flex flex-col gap-10 mb-20'>
                <h3 className='text-b1-700 text-base' onClick={onChargerComp}>충전기 간 비교 분석</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DRDetailModal